const da = {
  meta: {
    home: { title: "Centauros — Bliv betalt uden at jagte kunder", description: "Definér betalingspolitikker, automatisér påmindelser, generér fakturaer og bliv betalt uden at jagte nogen. Alt fra mobilen." },
    privacy: { title: "Privatlivspolitik — Centauros", description: "Hvordan Centauros beskytter og behandler dine data." },
    terms: { title: "Servicevilkår — Centauros", description: "Vilkår for at bruge Centauros." },
    support: { title: "Support — Centauros", description: "Hjælp og svar om Centauros." },
    contact: { title: "Kontakt — Centauros", description: "Tal med Centauros-teamet." },
  },
  nav: { features: "Funktioner", how: "Sådan virker det", faq: "FAQ", contact: "Kontakt", download: "Download", dashboard: "Panel" },
  hero: {"line1": "At blive betalt burde ikke", "line2": "være endnu et job.", "subtitle": "Sæt reglerne fra starten, automatisér opfølgningen og stop med at jagte dine kunder for at få betaling.", "functional": "Med Centauros definerer du betalingspolitikker, automatiserer påmindelser, genererer fakturaer og holder hver betaling under kontrol.", "ctaPrimary": "Download Centauros", "ctaSecondary": "Se hvordan det virker", "note": "Ingen skjulte gebyrer · Sikre betalinger med Stripe", "availability": "Tilgængelig til iPhone og Android"},
  marquee: ["Bygget til hesteprofessionelle", "Sikkert", "Hurtigt", "Pålideligt", "Bliv betalt uden at jagte"],
  problem: {"label": "Problemet", "title": "At blive betalt er problemet. Godt arbejde er ikke nok, hvis opkrævning bliver endnu et job.", "intro": "Du bliver betalt sent, jagter dine kunder og lægger ud med tid, materialer og penge. Det er de reelle omkostninger.", "chapters": [{"n": "01", "title": "Betalinger der kommer sent", "text": "Du ender med at finansiere kunden med din egen tid og dine penge."}, {"n": "02", "title": "Jagte kunder", "text": "Akavede beskeder, opkald og mails, der burde kunne undgås."}, {"n": "03", "title": "Uklare regler", "text": "Når vilkårene ikke sættes fra start, skaber det konflikt at kræve senere."}, {"n": "04", "title": "Manglende betaling uden overblik", "text": "Ikke at vide, hvad du opkræver, hvornår, eller hvad der er forfaldent."}, {"n": "05", "title": "Alternativomkostning", "text": "Hver time med at rykke er en time mindre til arbejde eller nye kunder."}]},
  solution: {
    label: "Løsningen",
    title: "Centauros automatiserer opkrævningen fra ende til anden.",
    subtitle: "Indstil én gang. Lad det arbejde for dig.",
    items: ["Betalingspolitikker", "Påmindelser", "Fakturaer", "Betalinger", "Opfølgning", "Afstemning"],
    footer: "Alt fra mobilen.",
  },
  how: {
    label: "Sådan virker det",
    title: "Fire trin. Nul friktion.",
    steps: [
      { title: "Opret kunde", text: "Tilføj din kunde på få sekunder." },
      { title: "Vælg politik", text: "Bestem hvornår og hvordan der opkræves automatisk." },
      { title: "Send", text: "Centauros udsteder og sender fakturaen for dig." },
      { title: "Bliv betalt", text: "Betalingen kommer af sig selv. Uden manuelle påmindelser." },
    ],
  },
  screens: {
    label: "Skærme",
    title: "Designet med besættelse for detaljen.",
    subtitle: "Hver skærm bygget til at gøre opkrævning usynlig.",
    items: [
      { title: "Opkrævning", text: "Alt hvad du har til gode, på ét blik." },
      { title: "Politikker", text: "Klare, genanvendelige betalingsregler." },
      { title: "Fakturaer", text: "Generér og send med ét tryk." },
      { title: "Betalinger", text: "Sikre, med Stripe, i realtid." },
    ],
  },
  features: {
    label: "Funktioner",
    title: "Alt hvad du behøver for at blive bedre betalt.",
    cards: [
      { title: "Fuld kontrol", text: "Et klart overblik over hver betaling og kunde." },
      { title: "Automatisering", text: "Gentagne opgaver kører af sig selv." },
      { title: "Fakturering", text: "Professionelle fakturaer genereret med det samme." },
      { title: "Opkrævning", text: "Automatiske betalinger efter dine politikker." },
      { title: "Team", text: "Inviter dit team og arbejd sammen." },
      { title: "Sikkerhed", text: "Sikker infrastruktur og beskyttede data." },
      { title: "Betalinger", text: "Bliv betalt med kort sikkert via Stripe." },
      { title: "Historik", text: "Hver bevægelse registreret og afstemt." },
    ],
  },
  audience: {
    label: "Til hvem",
    title: "Lavet til dem, der lever af deres arbejde.",
    subtitle: "Hvis din tid tæller, er Centauros til dig.",
    roles: ["Dyrlæger", "Beslagsmede", "Trænere", "Transportører", "Hesteprofessionelle"],
    note: "Og enhver professionel, der vil blive bedre betalt.",
  },
  security: {
    label: "Sikkerhed",
    title: "Dine penge og data, beskyttet.",
    subtitle: "Bygget på betroet infrastruktur.",
    points: [
      { title: "Betalinger med Stripe", text: "Vi behandler betalinger med branchens førende standard." },
      { title: "Sikker infrastruktur", text: "Kryptering under overførsel og i hvile." },
      { title: "Privatliv", text: "Dine data er dine. Vi sælger dem aldrig." },
      { title: "Databeskyttelse", text: "Overholdelse og bedste praksis by design." },
      { title: "Ingen gemte kort", text: "Vi gemmer aldrig kortoplysninger." },
    ],
  },
  faq: {
    label: "Ofte stillede spørgsmål",
    title: "Alt hvad du vil vide.",
    items: [
      { q: "Hvad er Centauros?", a: "En app til at definere betalingspolitikker, automatisere påmindelser, generere fakturaer og blive betalt uden at jagte nogen." },
      { q: "Kræver det tekniske færdigheder?", a: "Nej. Det opsættes på minutter og virker fra mobilen." },
      { q: "Hvordan behandles betalinger?", a: "Betalinger behandles sikkert via Stripe." },
      { q: "Gemmer I mine kortoplysninger?", a: "Aldrig. Vi gemmer ingen kortoplysninger på noget tidspunkt." },
      { q: "Kan jeg automatisere påmindelser?", a: "Ja. Definér politikken én gang, så klarer Centauros resten." },
      { q: "Kan jeg generere fakturaer?", a: "Ja, professionelle fakturaer med det samme, klar til at sende." },
      { q: "Virker det til mit fag?", a: "Bygget til hesteprofessionelle og alle, der vil blive bedre betalt." },
      { q: "Kan jeg arbejde med mit team?", a: "Ja, du kan invitere dit team og samarbejde." },
      { q: "Findes det på flere sprog?", a: "Ja, Centauros findes på 12 sprog." },
      { q: "Hvor kan jeg downloade det?", a: "Snart i App Store til iPhone." },
    ],
  },
  finalCta: { title: "Start i dag.", subtitle: "Download Centauros og stop med at jagte kunder.", badge: "Download i App Store" },
  footer: {
    statement1: "At få betaling er ikke længere",
    statement2: "endnu et job.",
    download: "Download Centauros",
    secure: "Sikre betalinger",
    tagline: "Bliv betalt uden at jagte kunder.",
    colProduct: "Produkt", colCompany: "Virksomhed", colLegal: "Juridisk",
    links: { home: "Hjem", features: "Funktioner", faq: "FAQ", contact: "Kontakt", privacy: "Privatliv", terms: "Vilkår", support: "Support", download: "Download" },
    contactLabel: "Kontakt",
    rights: "© Centauros. Alle rettigheder forbeholdes.",
  },
  contact: {
    title: "Lad os tale sammen.",
    subtitle: "Har du et spørgsmål eller vil du vide mere? Skriv til os.",
    fields: { name: "Navn", email: "E-mail", subject: "Emne", message: "Besked" },
    placeholders: { name: "Dit navn", email: "dig@email.com", subject: "Hvordan kan vi hjælpe?", message: "Fortæl os..." },
    submit: "Send besked", sending: "Sender...", success: "Besked sendt. Vi vender tilbage snart.", error: "Kunne ikke sende. Prøv igen.", directLabel: "Eller skriv direkte til os på",
  },
  legal: {
    privacy: {
      title: "Privatlivspolitik", updated: "Senest opdateret: juni 2026",
      body: [
        { h: "Introduktion", p: "Hos Centauros tager vi dit privatliv alvorligt. Denne politik forklarer, hvilke data vi behandler og hvorfor." },
        { h: "Data vi behandler", p: "Vi behandler de data, der er nødvendige for tjenesten: din konto, de kunder du håndterer og de betalinger du foretager." },
        { h: "Betalinger", p: "Betalinger går via Stripe. Vi gemmer aldrig dine eller dine kunders kortoplysninger." },
        { h: "Brug af data", p: "Vi bruger kun dine data til at levere og forbedre tjenesten. Vi sælger aldrig dine oplysninger." },
        { h: "Dine rettigheder", p: "Du kan til enhver tid tilgå, rette eller slette dine data via support@centauros.app." },
      ],
    },
    terms: {
      title: "Servicevilkår", updated: "Senest opdateret: juni 2026",
      body: [
        { h: "Accept", p: "Ved at bruge Centauros accepterer du disse vilkår. Er du uenig, så brug ikke tjenesten." },
        { h: "Brug af tjenesten", p: "Du forpligter dig til at bruge Centauros lovligt og holde din konto sikker." },
        { h: "Betalinger", p: "Betalinger behandles via Stripe efter deres vilkår. Du er ansvarlig for dine kunderelationer." },
        { h: "Ansvar", p: "Centauros leveres \"som den er\". Vi arbejder for løbende tilgængelighed og sikkerhed." },
        { h: "Ændringer", p: "Vi kan opdatere disse vilkår. Relevante ændringer meddeles via appen." },
      ],
    },
    support: {
      title: "Support", updated: "Vi er her for at hjælpe.",
      intro: "Find hurtige svar eller kontakt os direkte. Vi svarer hurtigst muligt.",
      faqs: [
        { q: "Hvordan kommer jeg i gang?", a: "Download appen, opret din konto og tilføj din første kunde på minutter." },
        { q: "Hvordan automatiserer jeg opkrævning?", a: "Opret en betalingspolitik og tildel den til dine kunder. Resten er automatisk." },
        { q: "Jeg har et betalingsproblem?", a: "Skriv til support@centauros.app, så ser vi på det sammen." },
        { q: "Kan jeg eksportere mine data?", a: "Ja, du kan anmode om en eksport når som helst." },
      ],
      contactLine: "Brug for mere hjælp? Skriv til os på",
    },
  },
  common: { languageLabel: "Sprog", backHome: "Tilbage til forsiden", loading: "Indlæser..." },
  philosophy: {"label": "Filosofien", "title": "Betalingsreglerne fastsættes", "titleGreen": "før du begynder.", "text": "Nogle gange er det bedre at sige nej til en kunde end at tage en, der tvinger dig til at lægge ud med tid, penge og ressourcer uden at vide, hvornår du bliver betalt. Med Centauros aftaler du fra starten hvordan, hvornår og hvor meget der betales.", "points": ["Definere betalingspolitikker", "Forebygge problemer", "Sikre aftaler", "Automatisere opfølgning", "Bevare økonomisk kontrol", "Reducere friktion med kunden"]},
  showcase: {"label": 'Produktet', "slides": [{"id": "control", "title": "Styr alt, hvad", "green": "du skal opkræve", "text": "Et klart overblik over hver betaling og din forretning, altid ved hånden."}, {"id": "policies", "title": "Du bestemmer", "green": "hvordan og hvornår du får betaling", "text": "Forud, depositum + rest, ved afslutning eller løbende. Vælg den rette politik."}, {"id": "clients", "title": "Hver kunde,", "green": "al den info du har brug for", "text": "Data, betalinger, abonnementer og historik ét sted."}, {"id": "payments", "title": "Hver betaling,", "green": "under kontrol", "text": "Status i realtid, automatiske påmindelser og faktura med det samme."}, {"id": "impagos", "title": "Opdag manglende betaling", "green": "før den vokser", "text": "Centauros følger op, rykker og hjælper dig med at inddrive det forfaldne."}, {"id": "facturacion", "title": "Betalinger og fakturaer", "green": "altid afstemt", "text": "Udsted, gennemgå og afstem alle dine fakturaer ét sted."}, {"id": "equipo", "title": "Dit team,", "green": "alt under kontrol", "text": "Inviter dit team, tildel roller og håndtér opkrævningen sammen."}]},
  badges: {"appStoreTop": "Hent i", "appStoreLabel": "App Store", "playTop": "Hent den på", "playLabel": "Google Play"},
  partners: {"label": "Drevet af førende betalingspartnere"},
  dashboard: {
    loginTitle: "Centauros-panel", loginSubtitle: "Privat adminadgang.",
    email: "E-mail", password: "Adgangskode", signIn: "Log ind", signingIn: "Logger ind...", invalid: "Ugyldige oplysninger.", logout: "Log ud",
    nav: { overview: "Oversigt", users: "Brugere", workspaces: "Arbejdsområder", activity: "Aktivitet", incidents: "Hændelser" },
    metrics: { users: "Brugere i alt", active: "Aktive brugere", workspaces: "Arbejdsområder", incidents: "Åbne hændelser", collected: "Opkrævet i alt" },
    tableUsers: { name: "Navn", email: "E-mail", profession: "Erhverv", status: "Status" },
    tableWorkspaces: { name: "Arbejdsområde", members: "Medlemmer", plan: "Plan", collected: "Opkrævet" },
    tableIncidents: { title: "Titel", workspace: "Arbejdsområde", severity: "Alvor", status: "Status" },
    recentActivity: "Seneste aktivitet",
  },
  policies: {
    label: "Betalingspolitikker",
    title: "Du bestemmer, hvordan og hvornår du får betaling.",
    subtitle: "Vælg den politik, der passer til hver kunde, og Centauros anvender den automatisk.",
    methods: [
      { name: "Forudbetaling", desc: "Opkræv hele beløbet, før du går i gang. Nul risiko." },
      { name: "Depositum + restbeløb", desc: "Et depositum nu og resten, når arbejdet er færdigt." },
      { name: "Betaling ved afslutning", desc: "Kunden betaler automatisk, når du er færdig." },
      { name: "Tilbagevendende betaling", desc: "Abonnementer og rater, der trækkes automatisk hver periode." },
      { name: "Senere ekstra", desc: "Tilføj ekstra omkostninger efter servicen, helt uden besvær." },
      { name: "Betaling pr. milepæl", desc: "Del betalingen op i faser, og få betaling undervejs." },
    ],
    ui: { upfront: "Forud", paid: "Betalt", pending: "Afventer", total: "I alt", deposit: "Depositum", balance: "Restbeløb", completed: "Fuldført", dueOnFinish: "Ved afslutning", monthly: "Månedligt", nextCharge: "Næste træk", extra: "Ekstra", milestone: "Milepæl" },
  },
  redesign: { comingSoon: "Kommer snart" },
  appui: { hello: "Hej", toCollect: "Til opkrævning", collected: "Modtaget", overdue: "Forfalden", activity: "Aktivitet", pending: "Afventer", paid: "Betalt", advance: "Forud", extra: "Ekstra", payNow: "Betal nu" },
  faqx: [
    { q: "Hvad er Centauros?", a: "Centauros er en platform til at definere betalingspolitikker, automatisere betalinger, generere fakturaer og reducere restancer uden at jage dine kunder. Du opsætter dine regler én gang, og appen opkræver, påminder og afstemmer for dig." },
    { q: "Hvem er det til?", a: "Til enhver professionel eller virksomhed, der fakturerer for deres ydelser: trænere, dyrlæger, advokater, konsulenter, bureauer, klinikker, fitnesscentre eller servicevirksomheder. Uanset om du fakturerer løbende eller pr. projekt, tilpasser Centauros sig din måde at arbejde på." },
    { q: "Skal mine kunder installere appen?", a: "Nej. Dine kunder modtager betalingslinks og beskeder direkte, uden at downloade noget. Kun du, den professionelle, bruger Centauros-appen." },
    { q: "Hvilke betalingsmetoder kan jeg acceptere?", a: "Takket være Stripe kan du acceptere kredit- og betalingskort, Apple Pay, Google Pay og de øvrige metoder, der er tilgængelige i dit land. De konkrete metoder afhænger af Stripes dækning i hver region." },
    { q: "Kan jeg bestemme, hvordan og hvornår jeg får betaling?", a: "Ja. Forudbetaling, depositum + restbeløb, betaling ved afslutning, tilbagevendende betalinger, senere ekstra eller betaling pr. milepæl. Du vælger den politik, der passer til hver kunde eller ydelse." },
    { q: "Genererer Centauros fakturaer automatisk?", a: "Ja. Det kan oprette kladder, udstede fakturaer automatisk efter betaling eller følge den faktureringspolitik, du opsætter. Alle registreres og er klar til at sende." },
    { q: "Hvad sker der, hvis en kunde ikke betaler?", a: "Centauros følger op for dig: automatiske påmindelser, styring af forfaldsdatoer og markering af restancer, så du får det udestående ind uden akavede samtaler." },
    { q: "Er Centauros sikkert?", a: "Ja. Betalinger håndteres udelukkende via Stripe, data sendes krypteret, og vi gemmer aldrig kortoplysninger. Platformen følger god sikkerhedspraksis." },
    { q: "I hvilke lande er det tilgængeligt?", a: "Centauros er bygget til at fungere internationalt. De tilgængelige betalingsmetoder afhænger af de lande, Stripe understøtter, som dækker de fleste markeder i Europa, Amerika og andre regioner." },
    { q: "Hvordan kommer jeg i gang?", a: "Download appen, opret din konto og opsæt din første betalingspolitik på få minutter. Derfra kan du begynde at opkræve og automatisere dine betalinger." },
  ],
  legalx: {
    eyebrow: "Juridisk", contents: "Indhold", questions: "Spørgsmål til denne side? Skriv til os.",
    navPrivacy: "Privatliv", navTerms: "Vilkår", navCookies: "Cookies", navSupport: "Support",
    cookiesMetaTitle: "Cookiepolitik — Centauros", cookiesMetaDesc: "Hvordan Centauros bruger cookies og lignende teknologier.",
  },
  product2: {
    p1title: "Stop jagten. Begynd at få betaling.",
    p1sub: "Manuel opfølgning koster dig penge. Med Centauros fastsætter du politikken og får betaling automatisk, uden akavede samtaler.",
    p1cta: "Download Centauros",
    p1link: "Se hvordan det virker",
    p1cardTitle: "For hver 1.000 € faktureret",
    p1cardCol: "Får du reelt",
    p1rows: [
      { name: "Centauros", amount: "1.000 €" },
      { name: "Manuelle påmindelser", amount: "910 €", delta: "−90 €" },
      { name: "Uden opfølgning", amount: "820 €", delta: "−180 €" },
    ],
    p2title: "Få betaling for dit arbejde, uden friktion.",
    p2sub: "Betalingslinks, politikker og automatiske fakturaer. Du sætter reglerne én gang, og Centauros klarer resten.",
    p2cta: "Se hvordan det virker",
    p2policy: "Politik · Depositum + restbeløb",
    p2sendLabel: "Kunden betaler",
    p2client: "Kunde",
    p2info: "Tilbagevendende betaling? Sæt den op én gang, og den trækkes automatisk hver periode.",
    p2recipLabel: "Du modtager",
    p2you: "Dig",
    p2arrives: "Trukket",
    p2arrivesVal: "I dag · automatisk",
    p2fees: "Gebyrer",
    p2feesVal: "Inkluderet",
    p3title: "Gør meget mere med Centauros.",
    p3sub: "Det handler ikke kun om at få betaling: administrer kunder, fakturaer, restancer og dit team ét sted.",
    p3cta: "Opret konto",
    p3cardLabel: "Til afregning",
    p3feat: "Få betaling med det samme",
    p3featDesc: "Betalingslinks og automatisk opkrævning drevet af Stripes infrastruktur.",
    p3check: "Flere betalingsmetoder",
    p3cta2: "Udforsk opkrævninger",
    p4title: "Få de restancer tilbage, du havde opgivet.",
    p4sub: "Centauros rykker automatisk for forsinkede betalinger med påmindelser og nye forsøg, indtil du får betaling.",
    p4cta: "Se hvordan det virker",
    p4cardLabel: "Genindvundne restancer",
    p4foot: "Fagfolk genindvinder i gennemsnit 38 % flere restancer i de første 6 måneder.",
  },
  pricing: {
    label: "Priser",
    title: "Klare priser. Ingen overraskelser.",
    subtitle: "Du betaler kun, når du får betaling. Stripe tager sit gebyr for at behandle betalingen, og Centauros lægger 1 % til for automatiseringen, opkrævningen og hele platformen.",
    stripeTitle: "Stripe-gebyr",
    stripeDesc: "Stripe behandler betalingen sikkert. Gebyret varierer afhængigt af land og betalingsmetode; det viste eksempel gælder europæiske kort.",
    centaurosTitle: "Centauros-gebyr",
    centaurosDesc: "1 % af beløbet for automatisering, opfølgning på opkrævninger og hele platformen. Ingen skjulte månedlige gebyrer.",
    calcTitle: "Beregn, hvad du modtager",
    invoiceAmount: "Fakturabeløb",
    stripeFee: "Stripe-gebyr",
    centaurosFee: "Centauros-gebyr (1 %)",
    received: "Den professionelle modtager",
    note: "Stripes reelle gebyr kan variere afhængigt af land og betalingsmetode. De viste beløb er et vejledende eksempel.",
  },
  cookie: {
    title: "Dit privatliv, dit valg",
    intro: "Vi bruger cookies, så Centauros fungerer korrekt, husker dine præferencer og for anonymt at forstå, hvordan siden bruges. Du vælger, hvad der aktiveres, og kan ændre dit valg når som helst.",
    required: "Altid til",
    acceptAll: "Accepter alle",
    rejectAll: "Afvis alle",
    save: "Gem præferencer",
    reopen: "Cookie-præferencer",
    footnote: "Du kan ændre dit samtykke når som helst via sidefoden.",
    policyLink: "Cookiepolitik",
    categories: {
      necessary: { name: "Nødvendige", desc: "Afgørende for, at siden fungerer og er sikker. De kan ikke slås fra." },
      preferences: { name: "Præferencer", desc: "Husker dine indstillinger, som sprog, for en mere behagelig oplevelse." },
      analytics: { name: "Analyse", desc: "Hjælper os med anonymt at forstå, hvordan siden bruges, så vi kan forbedre den." },
      marketing: { name: "Marketing", desc: "Gør det muligt at vise mere relevant indhold og annoncer, på og uden for siden." },
    },
  },
};
export default da;
